"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.criteriaDict = exports.activationOrDeactivationCriteria = exports.scoreVariationCriteria = exports.ComparaisonCriteria = exports.FlagCriteria = exports.Criteria = void 0;
const event_1 = require("./event");
const utils_1 = require("./utils");
class Criteria {
    constructor(id, mesure, crit_param) {
        this.id = id;
        this.crit_param = crit_param;
        this.mesure = mesure;
    }
    select_data(dataStream) {
        return dataStream.slice(-this.crit_param.stepToCompute);
    }
}
exports.Criteria = Criteria;
class FlagCriteria extends Criteria {
    constructor(id, mesure, crit_param) {
        super(id, mesure, crit_param);
        this.greater_than_threshold = 0;
        this.ref_point = 0;
        this.nb_rep = 0;
    }
    event_handler(eventList) {
        let event = eventList;
        event = event.data;
        if (event) {
            this.ref_point = event.ref_point;
            this.reference_mesure = event.reference_mesure;
            this.state = event.state;
            this.checking_variations = event.variation;
            this.nb_rep = event.nb_rep;
            this.successif = event.successif;
            this.greater_than_threshold = event.greater;
            if (event.type == 'improvement') {
                this.greater_than_threshold = 0;
            }
        }
    }
    check_criteria_completion(data) {
        if (!this.greater_than_threshold) {
            this.greater_than_threshold = 1 * Number(data > this.crit_param.threshold);
            return this.output("toSave");
        }
        if (this.nb_rep - this.ref_point === this.crit_param.nb_step && !this.greater_than_threshold) {
            this.flag = 1;
            return this.output("yellowFlag");
        }
        else if (this.nb_rep - this.ref_point === 2 * this.crit_param.nb_step && !this.greater_than_threshold && this.flag != 2) {
            this.flag = 2;
            return this.output("orangeFlag");
        }
        else if (this.nb_rep - this.ref_point === 3 * this.crit_param.nb_step && !this.greater_than_threshold) {
            this.flag = 3;
            return this.output("redFlag");
        }
        else {
            return this.output("toSave");
        }
    }
    update(dataStream, eventList) {
        this.event_handler(eventList);
        this.data = this.select_data(dataStream);
        let current_mesure = this.mesure(this.data);
        return this.check_criteria_completion(current_mesure);
    }
    output(eventType) {
        if (eventType == 'toSave') {
            let context = { 'type': "flag", 'nb_question': this.nb_rep, 'data': this.data, 'state': this.state, 'successif': this.successif, 'nb_rep': this.nb_rep, 'reference_mesure': this.reference_mesure, 'ref_point': this.ref_point, 'greater': this.greater_than_threshold };
            return (0, event_1.createEvent)('update', context);
        }
        else {
            let context = { 'type': eventType, 'nb_question': this.nb_rep, 'data': this.data, 'state': this.state, 'successif': this.successif, 'nb_rep': this.nb_rep, 'reference_mesure': this.reference_mesure, 'ref_point': this.ref_point, 'greater': this.greater_than_threshold };
            let event = (0, event_1.createEvent)('scoreVariation', context);
            return event;
        }
    }
}
exports.FlagCriteria = FlagCriteria;
class ComparaisonCriteria extends Criteria {
    constructor(id, mesure, crit_param) {
        super(id, mesure, crit_param);
        this.tolerance = crit_param.tolerance;
        this.checking_variations = 0;
        this.nb_rep = 0;
        this.ref_point = 0;
        this.reference_mesure = 0;
    }
    event_handler(lastEvent) {
        let event = lastEvent;
        event = event.data;
        this.ref_point = event.ref_point;
        this.reference_mesure = event.reference_mesure;
        this.state = event.state;
        this.checking_variations = event.checking_var;
        this.nb_rep = event.nb_rep + 1;
        this.greater_than_threshold = event.greater;
        this.successif = event.successif;
    }
    check_variation() {
        // Cas amélioration
        if (this.current_mesure - this.reference_mesure >= this.tolerance) {
            this.state = 'improvement';
            this.successif = 1;
            if (this.successif == this.crit_param.nb_step) {
                this.maj_marqueur(this.state, true);
                return this.output('improvement');
            }
            else {
                return this.output('toSave');
            }
        }
        // Cas stable
        else if (Math.abs(this.current_mesure - this.reference_mesure) <= this.tolerance) {
            this.state = 'stable';
            this.successif = 1;
            if (this.successif == this.crit_param.nb_step) {
                this.maj_marqueur(this.state, true);
            }
            else {
                return this.output('toSave');
            }
        }
        // Cas perte de niveau
        else if (this.reference_mesure - this.current_mesure >= this.tolerance) {
            this.state = 'worst';
            this.successif = 1;
            if (this.successif == this.crit_param.nb_step) {
                this.maj_marqueur(this.state, true);
            }
            else {
                return this.output('toSave');
            }
        }
    }
    check_criteria_completion() {
        // pour le premier calcul de la mesure de ref on attend stepToCompute score
        if (this.nb_rep <= this.crit_param.stepToCompute) {
            this.reference_mesure = this.current_mesure;
            return this.output('toSave');
        }
        // une fois que l'élève à fait stepToCompute exo on regarde si sur la fenêtre glissante de taille nb_step on a une MMP supérieur à celle de référence
        else {
            if (!this.successif) {
                return this.check_variation();
            }
            else {
                // si on a commencé à détecter une variation on vérifie si elle se stabilise sur nb_step étape
                switch (this.state) {
                    case 'improvement':
                        this.successif = (this.successif + 1) * Number(this.current_mesure >= this.reference_mesure + this.tolerance);
                        return (this.check_state_completion('improvement', true));
                    case 'worst':
                        this.successif = (this.successif + 1) * Number(this.current_mesure <= this.reference_mesure - this.tolerance);
                        return (this.check_state_completion('regression', true));
                    case 'stable':
                        this.successif = (this.successif + 1) * Number(Math.abs(this.current_mesure - this.reference_mesure) <= this.tolerance);
                        if (this.current_mesure < this.crit_param.threshold) {
                            return (this.check_state_completion('blocked'));
                        }
                        else {
                            return (this.check_state_completion('stable'));
                        }
                    default:
                        return this.output('toSave');
                }
            }
        }
    }
    ;
    check_state_completion(eventToGenerate, updateMesure = false) {
        if (this.successif === this.crit_param.nb_step) {
            this.maj_marqueur(this.state, updateMesure);
            return this.output(eventToGenerate);
        }
        else if (this.successif == 0) {
            this.maj_marqueur(this.state);
            this.check_variation();
            return this.output('toSave');
        }
        else {
            return this.output('toSave');
        }
    }
    maj_marqueur(state, maj_mesure) {
        state = 0;
        this.successif = 0;
        this.checking_variations = 0;
        if (maj_mesure) {
            this.old_mesure = this.reference_mesure;
            this.reference_mesure = this.current_mesure;
            this.ref_point = this.nb_rep;
        }
    }
    update(dataStream, lastEvent) {
        this.event_handler(lastEvent);
        let data = this.select_data(dataStream);
        this.current_mesure = Math.round(this.mesure(data) * 100) / 100;
        return this.check_criteria_completion();
    }
    output(eventType) {
        // if improvement need to send old_ref and new measure
        if (eventType == 'improvement') {
            let context = { type: eventType, ref_point: this.ref_point, old_mesure: this.old_mesure, reference_mesure: this.current_mesure, greater: this.greater_than_threshold, nb_rep: this.nb_rep, criteria: this };
            return (0, event_1.createEvent)('scoreVariation', context);
        }
        // to save last update for activity/objective
        else if (eventType == 'toSave') {
            let context = { state: this.state, successif: this.successif, reference_mesure: this.reference_mesure, current_mesure: this.current_mesure, ref_point: this.ref_point, greater: this.greater_than_threshold, nb_rep: this.nb_rep };
            return (0, event_1.createEvent)('update', context);
        }
        // other variation does not need different treatment
        else {
            let context = { type: eventType, ref_point: this.ref_point, reference_mesure: this.reference_mesure, new_mesure: this.current_mesure, greater: this.greater_than_threshold, nb_rep: this.nb_rep, criteria: this };
            return (0, event_1.createEvent)('scoreVariation', context);
        }
    }
}
exports.ComparaisonCriteria = ComparaisonCriteria;
class scoreVariationCriteria extends Criteria {
    constructor(id, mesure, crit_param) {
        super(id, mesure, crit_param);
    }
    event_handler(eventList) {
        this.cur_event = eventList[eventList.length - 1];
        this.eventList = eventList;
    }
    check_criteria_completion() {
        switch (this.cur_event.data.variationType) {
            case "improvement":
                return this.check_improvementEvent();
            case "regression":
            case 'blocked':
            case 'stable':
                return this.output(utils_1.eventToMessageType[this.cur_event.data.variationType]);
        }
    }
    /**
       * check which type of improvement it is based on the criteria that detected the variation to distinguish between instantaneous improvement and long improvement
       * deicde which message to generate based on the type of improvement and permanenState
       * @param eventStream
       */
    check_improvementEvent() {
        if (this.cur_event.data.variationData.criteria.crit_param.stepToCompute == 1) {
            if (this.cur_event.data.permanenState) {
                return this.output('improvementInstMessage');
            }
        }
        else {
            if (this.eventList.length > 2 && this.eventList[this.eventList.length - 2].data.variationType == "blocked") {
                return this.output('overcomedBlockingEvent');
            }
            else {
                return this.output('improvementMessage');
            }
        }
    }
    generate_data(message_type) {
        let event_data = {};
        event_data["graphLevel"] = this.cur_event.data.graphLevel;
        event_data['objectiveId'] = this.cur_event.data.objectiveId;
        event_data['activityId'] = this.cur_event.data.activityId;
        event_data['exerciseId'] = this.cur_event.data.exerciseId;
        event_data['messageType'] = message_type;
        event_data['messageID'] = message_type + this.cur_event.data.graphLevel;
        return event_data;
    }
    update(eventList) {
        this.event_handler(eventList);
        return this.check_criteria_completion();
    }
    output(eventType) {
        let event_data = this.generate_data(eventType);
        return (0, event_1.createEvent)(eventType, event_data);
    }
}
exports.scoreVariationCriteria = scoreVariationCriteria;
class activationOrDeactivationCriteria extends Criteria {
    constructor(id, mesure, crit_param) {
        super(id, mesure, crit_param);
        this.last_exId = "";
    }
    event_handler(eventList) {
        this.cur_event = eventList[eventList.length - 1];
    }
    check_criteria_completion() {
        if (this.cur_event.type.includes("Deactivation")) {
            // in case multiple activities are deactivated at the same time we look at the exercise Id to see if they are related
            if (this.cur_event.data.exerciseId != this.last_exId) {
                if (this.cur_event.type.includes('Act')) {
                    this.output(utils_1.eventToMessageType[this.cur_event.type]);
                }
                // first objective deactivation change the states
                else {
                    this.output(utils_1.eventToMessageType[this.cur_event.type]);
                }
            }
            this.last_exId = this.cur_event.data.exerciseId;
        }
        // activation event. Same treatment for objective and activity 
        else {
            this.output(utils_1.eventToMessageType[this.cur_event.type]);
        }
    }
    generate_data(message_type) {
        let event_data = {};
        event_data["graphLevel"] = this.cur_event.data.graphLevel;
        event_data['objectiveId'] = this.cur_event.data.objectiveId;
        event_data['activityId'] = this.cur_event.data.activityId;
        event_data['exerciseId'] = this.cur_event.data.exerciseId;
        event_data['messageType'] = message_type;
        event_data['messageID'] = message_type + this.cur_event.data.graphLevel;
        return event_data;
    }
    update(eventList) {
        this.event_handler(eventList);
        return this.check_criteria_completion();
    }
    output(eventType) {
        let event_data = this.generate_data(eventType);
        return (0, event_1.createEvent)(eventType, event_data);
    }
}
exports.activationOrDeactivationCriteria = activationOrDeactivationCriteria;
exports.criteriaDict = { 'flag': FlagCriteria, 'comparaison': ComparaisonCriteria };
